/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown>, width: NonNullable<unknown>, height: NonNullable<unknown> }} Error_Product_Image_Export_SizeInputs */

const vi_error_product_image_export_size = /** @type {(inputs: Error_Product_Image_Export_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ảnh xuất phải đúng ${i?.size}×${i?.size} px (đang là ${i?.width}×${i?.height}). Tải lại trang rồi lưu lại.`)
};

/**

* @param {Error_Product_Image_Export_SizeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_image_export_size = /** @type {((inputs: Error_Product_Image_Export_SizeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Image_Export_SizeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_image_export_size(inputs)
});